import { useMemo } from 'react';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import {
  DATE_RANGE_SEARCH_PARAM_KEY,
  ENTITY_ID_SEARCH_PARAM_KEY,
  REGISTER_ID_SEARCH_PARAM_KEY,
} from '@/modules/common/constants/search-params.ts';
import { investorDashboardPaths } from '@/modules/investor-dashboard/routes.tsx';
import { useIsAllNotificationsRead } from '@/modules/issuer-dashboard/queries/event-logs.ts';
import { SidebarMenuItem } from 'ui';
import {
  BriefcaseGrayIcon,
  BriefcaseWhiteIcon,
  CertificateGrayIcon,
  CertificateWhiteIcon,
  FileGreyIcon,
  FileWhiteIcon,
  HistoryGrayIcon,
  HistoryWhiteIcon,
  HomeGrayIcon,
  HomeWhiteIcon,
  NotificationsDisabledIcon,
  NotificationsGrayIcon,
  NotificationsWhiteIcon,
  SwitchGrayIcon,
  SwitchWhiteIcon,
} from 'ui/icons';

export const useSidebarOptions = (): SidebarMenuItem[] => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const entity_id = params.get(ENTITY_ID_SEARCH_PARAM_KEY) || '';
  const register = params.get(REGISTER_ID_SEARCH_PARAM_KEY) || 'all';
  const date_range = params.get(DATE_RANGE_SEARCH_PARAM_KEY) || '1';

  const { data: isAllNotificationRead } = useIsAllNotificationsRead();

  const search = createSearchParams({ entity_id, register, date_range }).toString();

  return useMemo<SidebarMenuItem[]>(
    () => [
      {
        label: 'Dashboard',
        icon: HomeGrayIcon,
        activeIcon: HomeWhiteIcon,
        disabledIcon: HomeGrayIcon,
        pathname: investorDashboardPaths.static.dashboard,
        onClick: () =>
          navigate(
            {
              pathname: investorDashboardPaths.static.dashboard,
              search,
            },
            {
              replace: false,
            },
          ),
      },
      {
        label: 'My investments',
        icon: BriefcaseGrayIcon,
        activeIcon: BriefcaseWhiteIcon,
        disabledIcon: BriefcaseGrayIcon,
        pathname: investorDashboardPaths.static.myInvestments,
        onClick: () =>
          navigate(
            {
              pathname: investorDashboardPaths.static.myInvestments,
              search,
            },
            {
              replace: false,
            },
          ),
      },
      {
        label: 'Activity',
        icon: HistoryGrayIcon,
        activeIcon: HistoryWhiteIcon,
        disabledIcon: HistoryGrayIcon,
        pathname: investorDashboardPaths.static.activity,
        onClick: () =>
          navigate(
            {
              pathname: investorDashboardPaths.static.activity,
              search,
            },
            {
              replace: false,
            },
          ),
      },
      {
        label: 'Transactions history',
        icon: SwitchGrayIcon,
        activeIcon: SwitchWhiteIcon,
        disabledIcon: SwitchGrayIcon,
        pathname: investorDashboardPaths.static.transactionsHistory,
        onClick: () =>
          navigate(
            {
              pathname: investorDashboardPaths.static.transactionsHistory,
              search,
            },
            {
              replace: false,
            },
          ),
      },
      // {
      //   label: 'Opportunities',
      //   disabled: true,
      //   icon: SeedingDisabledIcon,
      //   activeIcon: SeedingWhiteIcon,
      //   disabledIcon: SeedingDisabledIcon,
      // },
      {
        label: 'Reports',
        icon: FileGreyIcon,
        activeIcon: FileWhiteIcon,
        disabledIcon: FileGreyIcon,
        pathname: investorDashboardPaths.static.reports,
        onClick: () =>
          navigate(
            {
              pathname: investorDashboardPaths.static.reports,
              search,
            },
            {
              replace: false,
            },
          ),
      },
      {
        label: 'Event logs',
        icon: NotificationsGrayIcon,
        activeIcon: NotificationsWhiteIcon,
        disabledIcon: NotificationsDisabledIcon,
        notification: isAllNotificationRead?.all_is_read === false,
        pathname: investorDashboardPaths.static.notifications,
        onClick: () =>
          navigate(
            {
              pathname: investorDashboardPaths.static.notifications,
              search,
            },
            {
              replace: false,
            },
          ),
      },
      {
        label: 'Certificates',
        icon: CertificateGrayIcon,
        activeIcon: CertificateWhiteIcon,
        disabledIcon: CertificateGrayIcon,
        pathname: investorDashboardPaths.static.certificates,
        onClick: () =>
          navigate(
            {
              pathname: investorDashboardPaths.static.certificates,
              search,
            },
            {
              replace: false,
            },
          ),
      },
    ],
    [navigate, search, isAllNotificationRead],
  );
};
